<template>
	<a
		class="advertisement-card"
		:class="{ compact, 'fixed-height': Boolean(height), 'advertisement-card-overlay': isOverlay }"
		:style="height ? { height } : {}"
		:href="advertisement.buttonText ? null : advertisement.link"
		:target="isExternalLink ? '_blank' : null"
		rel="noopener"
		@click="advertisement.buttonText ? null : openLink($event)"
	>
		<div v-if="advertisement.html" class="advertisement-html" v-html="advertisement.html"></div>
		<template v-else>
			<img v-if="advertisement.image" :src="advertisement.image" :alt="advertisement.title" class="advertisement-image" />
			<div v-if="advertisement.title || advertisement.subtitle || advertisement.buttonText" class="advertisement-content">
				<p v-if="advertisement.title" class="advertisement-title">{{ advertisement.title }}</p>
				<p v-if="advertisement.subtitle" class="advertisement-subtitle">{{ advertisement.subtitle }}</p>
				<a
					v-if="advertisement.buttonText"
					class="advertisement-button"
					:href="advertisement.link"
					:target="isExternalLink ? '_blank' : null"
					rel="noopener"
					@click="openLink"
				>
					{{ advertisement.buttonText }}
				</a>
			</div>
		</template>
	</a>
</template>

<script>
export default {
	name: "AdvertisementBanner",
	props: {
		advertisement: { type: Object, required: true },
		compact: { type: Boolean, default: false },
		height: { type: String, default: null },
		preview: { type: Boolean, default: false },
	},
	computed: {
		isOverlay() {
			return String(this.advertisement.overlay).toLowerCase() === "true" && !this.advertisement.html;
		},
		isExternalLink() {
			return String(this.advertisement.link || "").toLowerCase().startsWith("http");
		},
	},
	methods: {
		openLink(event) {
			if (!this.advertisement.link || this.isExternalLink) {
				return;
			}

			event.preventDefault();
			if (!this.preview) {
				this.$router.push(this.advertisement.link);
			}
		},
	},
};
</script>

<style scoped>
.advertisement-card {
	height: 100%;
	color: inherit;
	text-decoration: none;
	cursor: default;
	display: flex;
	flex-direction: column;
	border: solid 1px var(--border-color);
	border-radius: 0.625rem;
	overflow: hidden;
	background-color: var(--color-white);
}
.advertisement-html {
	flex: 1;
}
.advertisement-html ::v-deep img,
.advertisement-html ::v-deep iframe {
	max-width: 100%;
	display: block;
}
.advertisement-card[href] {
	cursor: pointer;
}
.advertisement-card:focus:not(:focus-visible),
.advertisement-button:focus:not(:focus-visible) {
	outline: none;
}
.advertisement-image {
	width: 100%;
	height: 9rem;
	object-fit: cover;
	display: block;
}
.advertisement-content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	padding: 0.75rem 1rem 1rem;
}
.advertisement-title {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--primary-link-color);
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.advertisement-subtitle {
	margin: 0.25rem 0 0.75rem;
	font-size: 0.875rem;
	color: #838383;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.advertisement-button {
	margin-top: auto;
	padding: 0.375rem 1rem;
	border-radius: 0.5rem;
	background-color: var(--primary-color);
	color: var(--color-white);
	font-size: 0.875rem;
	font-weight: 500;
	text-decoration: none;
	cursor: pointer;
}
.advertisement-card.fixed-height .advertisement-image {
	flex: 1;
	height: auto;
	min-height: 0;
}
.advertisement-card.fixed-height .advertisement-content {
	flex: none;
}
.advertisement-card.fixed-height .advertisement-html {
	min-height: 0;
}

.advertisement-card.compact .advertisement-image {
	height: 7rem;
}
.advertisement-card.compact .advertisement-content {
	padding: 0.5rem 0.75rem 0.75rem;
}
.advertisement-card.compact .advertisement-title {
	font-size: 13px;
}
.advertisement-card.compact .advertisement-subtitle {
	font-size: 12px;
}
.advertisement-card.compact .advertisement-button {
	margin-top: 0.5rem;
	padding: 0.25rem 0.75rem;
	font-size: 12px;
}

/* Overlay: the image fills the card and the text sits on top */
.advertisement-card.advertisement-card-overlay {
	position: relative;
	min-height: 12rem;
}
.advertisement-card.advertisement-card-overlay.compact {
	min-height: 9rem;
}
.advertisement-card.advertisement-card-overlay .advertisement-image {
	position: absolute;
	inset: 0;
	height: 100%;
}
.advertisement-card.advertisement-card-overlay .advertisement-content {
	position: relative;
	flex: 1;
	justify-content: flex-end;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.75) 100%);
}
.advertisement-card.advertisement-card-overlay .advertisement-title {
	color: #ffffff;
}
.advertisement-card.advertisement-card-overlay .advertisement-subtitle {
	color: rgba(255, 255, 255, 0.9);
}
.advertisement-card.advertisement-card-overlay .advertisement-button {
	margin-top: 0;
}
</style>
